import { INavRoute } from 'app/components'
import { FunctionalReducer, IReducerAction } from 'app/redux/FunctionalReducer'
import ImmutableMap from 'app/utils/immutable/map';
import * as React from 'react'
import * as Redux from 'redux'

interface INavState {
  NavHeaderElement: JSX.Element
  NavRoutes: INavRoute[]
  Breadcrumb: string
  BreadcrumbPath: string
}

interface INavAction extends IReducerAction {
  type: string
  Breadcrumb?: {
    name: string
    path: string
  }
  NavRoutes?: INavRoute[]
  NavHeaderElement?: {
    status: string
    statusClassName: string
  }
}

const ActionTypes = {
  UPDATE_HEADER: 'nav/UPDATE_HEADER',
  UPDATE_NAV: 'nav/UPDATE_NAV',
  UPDATE_BREADCRUMB: 'nav/UPDATE_BREADCRUMB',
}

const createHeader = (status: string, statusClassName: string) => {
  return (
    <span>
      According to the figures, your finances will be at least <span className={statusClassName} style={{ fontWeight: 'bold' }}> {status} </span> to support you long-term.
    </span>
  )
}

const initialState = new ImmutableMap<INavState>({
  NavHeaderElement: null,
  NavRoutes: [],
  Breadcrumb: null,
  BreadcrumbPath: null,
})

const functionalReducer = new FunctionalReducer<ImmutableMap<INavState>, INavAction>(initialState)
  .whenTypeIs(ActionTypes.UPDATE_HEADER, (state, action) => {
    const { status, statusClassName } = action.NavHeaderElement
    const NavHeaderElement = createHeader(status, statusClassName)

    return state.update({ NavHeaderElement })
  })
  .whenTypeIs(ActionTypes.UPDATE_NAV, (state, action) => {
    const NavRoutes = action.NavRoutes

    return state.update({ NavRoutes })
  })
  .whenTypeIs(ActionTypes.UPDATE_BREADCRUMB, (state, action) => {
    const Breadcrumb = action.Breadcrumb.name
    const BreadcrumbPath = action.Breadcrumb.path

    return state.update({ Breadcrumb, BreadcrumbPath })
  })

export {
  functionalReducer,
  ActionTypes,
  INavState,
  INavAction,
}



// WEBPACK FOOTER //
// ./src/app/redux/Nav/reducer/index.tsx